export const AUTH = {
  SET_ERROR_MSG: 'AUTH__SET_ERROR_MSG',
  SET_USER: 'AUTH__SET_USER'
};

export const SOCKET = {
  CONNECT: 'SOCKET__CONNECT',
  DISCONNECT: 'SOCKET__DISCONNECT',
  SUBSCRIBE_TASK_DETAIL: 'SOCKET__SUBSCRIBE_TASK_DETAIL',
  SUBSCRIBE_TASK_LIST: 'SOCKET__SUBSCRIBE_TASK_LIST'
};

export const TASK_DETAIL = {
  SET_MODAL_TYPE: 'TASK_DETAIL__SET_MODAL_TYPE',
  SET_OPS_INFO_VISIBLE: 'TASK_DETAIL__SET_OPS_INFO_VISIBLE',
  SET_RES_MSG: 'TASK_DETAIL__SET_RES_MSG',
  SET_SUBSTAGES_VISIBLE: 'TASK_DETAIL__SET_SUBSTAGES_VISIBLE',
  SET_TASK: 'TASK_DETAIL__SET_TASK',
  SET_TP_INFO_VISIBLE: 'TASK_DETAIL__SET_TP_INFO_VISIBLE'
};

export const TASK_LIST = {
  SET_BULK_EDIT_MODE: 'TASK_LIST__SET_BULK_EDIT_MODE',
  SET_BULK_EDIT_TASKS: 'TASK_LIST__SET_BULK_EDIT_TASKS',
  SET_ORDER: 'TASK_LIST__SET_ORDER',
  SET_PAGE: 'TASK_LIST__SET_PAGE',
  SET_ERROR_MESSAGE: 'TASK_LIST__SET_ERROR_MESSAGE',
  SET_SHOW_ALL: 'TASK_LIST__SET_SHOW_ALL',
  SET_YEAR: 'TASK_LIST__SET_YEAR',
  SET_FILTERS: 'TASK_LIST__SET_FILTERS',
  SET_CURRENT_TAB: 'TASK_LIST__SET_CURRENT_TAB',
  SET_PAGE_NUMBER: 'TASK_LIST__SET_PAGE_NUMBER'
};
